import PropTypes from 'prop-types';

export const Props = {
  /**
   * List items to display in the list
   */
  items: PropTypes.array,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
